<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div
    class="scroll-wrapper ui basic segment"
    style="padding: 0"
    [ngClass]="{ loading: pending }"
  >
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast [(message)]="error"></esl-message-toast>
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
    </div>
    <app-tabset>
      <div class="ui blue pointing secondary menu">
        <a class="item" appTabHeader="1">Invoice info</a>
        <a class="item" appTabHeader="2">Payment Instruction</a>
      </div>
      <div class="ui basic segment" appTabContent="1">
        <div fxLayout="column" fxLayoutGap="25px">
          <div fxLayout="column">
            <div fxFlex><strong>Company Name</strong></div>
            <div fxFlex>{{ detailInvoice?.companyName || "-----" }}</div>
          </div>

          <!-- <div fxLayout="column" >
                                                <div fxFlex><strong> Company Address </strong></div>
                                                <div fxFlex ><label class="ui teal circular label" [ngClass]="{'green':detailInvoice.publicAccessEnabled}">{{detailInvoice?.accessTypes}}</label></div>
                                          </div>  -->

          <div fxLayout="column">
            <div fxFlex><strong>Company ID </strong></div>
            <div fxFlex>{{ detailInvoice?.customerNccId || "-----" }}</div>
          </div>
          <div fxLayout="column">
            <div fxFlex><strong>Invoice Number </strong></div>
            <div fxFlex>{{ detailInvoice?.invoiceNumber || "-----" }}</div>
          </div>
          <div fxLayout="column">
            <div fxFlex><strong>Amount </strong></div>
            <div fxFlex>
              {{ detailInvoice?.currencyCode }}
              {{ detailInvoice?.amount | number: ".2-2" }}
            </div>
          </div>
          <div fxLayout="column">
            <div fxFlex><strong>RC Number</strong></div>
            <div fxFlex>{{ detailInvoice?.companyRegNumber || "-----" }}</div>
          </div>

          <div fxLayout="column">
            <div fxFlex><strong>Service Type</strong></div>
            <div fxFlex>{{ detailInvoice?.categoryName || "-----" }}</div>
          </div>

          <!-- <div fxLayout="column" >
                                                <div fxFlex><strong>Invoice Advice Type </strong></div>
                                                <div fxFlex>{{detailInvoice?.invoiceType || '-----'}}</div>
                                          </div> -->

          <div fxLayout="column">
            <div fxFlex><strong>Invoice Category</strong></div>
            <div fxFlex>{{ detailInvoice?.invoiceType || "-----" }}</div>
          </div>

          <div fxLayout="column">
            <div fxFlex><strong>Licence Type </strong></div>
            <div fxFlex>{{ detailInvoice?.categoryName || "-----" }}</div>
          </div>

          <div fxLayout="column">
            <div fxFlex><strong>Validity Period</strong></div>
            <div fxFlex>{{ detailInvoice?.validityPeriod || "-----" }}</div>
          </div>

          <div fxLayout="column">
            <div fxFlex><strong>Start Date </strong></div>
            <div fxFlex>
              {{ (detailInvoice?.serviceStartDate | date) || "-----" }}
            </div>
          </div>

          <div fxLayout="column">
            <div fxFlex><strong>End Date </strong></div>
            <div fxFlex>
              {{ (detailInvoice?.serviceEndDate | date) || "-----" }}
            </div>
          </div>
        </div>
      </div>
      <div class="ui basic segment" appTabContent="2">
        <div *ngIf="paymentInstructions">
          <div [innerHtml]="paymentInstructions"></div>
        </div>
        <div *ngIf="faqs">
          <div [innerHtml]="faqs"></div>
        </div>
      </div>
    </app-tabset>
  </div>
</div>
<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Back
  </button>
  <!-- <button class="ui  primary button" [ngClass]="{'yellow':pending}" [disabled]="!detailInvoice ||  detailInvoice.status == 'PAID'" (click)="submit()" autofocus>Pay now</button> -->
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    *ngIf="
      detailInvoice?.status != 'PAID' &&
      detailInvoice?.status != 'OVER_PAID' &&
      detailInvoice?.status != 'CANCELLED'
    "
    [disabled]="pending"
    (click)="submit()"
    autofocus
  >
    Pay now
  </button>
</div>
